const BASE_PATH = "app/messenger/";

export const SET_CHAT_LIST = `${BASE_PATH}set-chatList`;
export const SET_CHAT = `${BASE_PATH}set-chat`;
export const SET_ACTIVE_TAB = `${BASE_PATH}set-active-chat`;
export const ADD_UPDATE_MESSAGE = `${BASE_PATH}add-update-message`;
export const FIND_AND_REMOVE_MESSAGE = `${BASE_PATH}find-and-remove-message`;
export const FIND_AND_UPDATE_MESSAGE = `${BASE_PATH}find-and-update-message`;
